import './App.css';
import Header from './components/Header';
import OurTeam from './components/OurTeam';
import Footer from './components/Footer';
import Vision from './components/Vision';
import Home from './components/Home';
import LastEvent from './components/LastEvent'
import ContactUs from './components/ContactUs';
import { BrowserRouter, Routes, Route } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* <Header /> */}
        <Routes>


          <Route exact path="/" element={<Home />} />
          <Route path='gallery' element={<LastEvent/>} />
          <Route path='contact-us' element={<ContactUs/>} />
        </Routes>
      </div>
    </BrowserRouter>
    // <h1>I think you didn't like it, so I stopped it :P</h1>
    // <h1>You didn't pay so I stopped it :P</h1>
  );
}

export default App;
